import nonEmptyString from '../inputValidators/nonEmptyStringValidator.js'

export default function (input) {

    if (!nonEmptyString(input)) {
        return false
    }

    const url = `https://api.dataforsyningen.dk/postnumre/${input}`

    return fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok')
            }
            return response.json()
        })
        .then(data => {
            return data.navn
        })
        .catch(() => null)
}
